import React from 'react';
import ImportEntries from 'Components/ImportEntries';
import { useTranslation } from 'react-i18next';

const ImporterInstructions = () => {
    const { t } = useTranslation();

    return (
        <>
            <ImportEntries.Title title={t('singleListImport.title')} dataTestId='list-page-import-title' />
            <ImportEntries.ImportInstructions
                dataTestId='list-page-import-instructions'
                instructions={
                    <>
                        {t('singleListImport.instructions')}{' '}
                        {t('singleListImport.fileSizeInstructions', {
                            // we might want to make that configurable but... we'll see.
                            fileSize: '100 MB',
                            fileTypes: '.CSV'
                        })}
                    </>
                }
            />
        </>
    );
};

export default ImporterInstructions;
